let cookie_notice = ( function( $ ) {

	let $remove_membership_link;

	let _init = function() {
		$remove_membership_link = $( '.remove-membership-number' );

		if ( $remove_membership_link.length > 0 ) {
			$remove_membership_link.on( 'click', _handle_remove_membership );
		}
	};

	let _handle_remove_membership = function( e ) {
		e.preventDefault();

		let data = {
			action: 'crate_remove_individual_user_membership',
			nonce: ScriptData.remove_individual_user_membership_nonce,
		};

		$.post( ScriptData.ajaxurl, data, _remove_membership_response );
	};

	let _remove_membership_response = function( res ) {
		if ( res.success && res.redirect ) {
			window.location.href = res.redirect;
		}
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = cookie_notice;